'use strict';

require('./kendo.core.js');
require('./kendo.fx.js');
require('./kendo.router.js');
require('./kendo.view.js');
require('./kendo.data.odata.js');
require('./kendo.data.xml.js');
require('./kendo.data.js');
require('./kendo.data.signalr.js');
require('./kendo.binder.js');
require('./kendo.userevents.js');
require('./kendo.draganddrop.js');
require('./kendo.mobile.scroller.js');
require('./kendo.popup.js');
require('./kendo.tooltip.js');
require('./html-sdnHcjkh.js');
require('./kendo.dataviz.core.js');
require('./kendo.dataviz.themes.js');
require('./kendo.dataviz.chart.js');
require('./kendo.dataviz.sankey.js');
require('./kendo.dataviz.gauge.js');
require('./kendo.dataviz.barcode.js');
require('./kendo.dataviz.qrcode.js');
require('./kendo.dataviz.stock.js');
require('./kendo.dataviz.sparkline.js');
require('./kendo.dataviz.map.js');
require('./kendo.dataviz.diagram.js');
require('./kendo.dataviz.treemap.js');
require('./kendo.licensing.js');
require('@progress/kendo-licensing');
require('./kendo.icons.js');
require('./kendo.html.icon.js');
require('./kendo.html.base.js');
require('@progress/kendo-svg-icons');
require('@progress/kendo-drawing');
require('./kendo.color.js');
require('@progress/kendo-charts/dist/es/core-export.js');
require('@progress/kendo-charts');
require('./kendo.breadcrumb.js');
require('@progress/kendo-charts/dist/es/chart-export.js');
require('./kendo.toolbar.js');
require('./kendo.splitbutton.js');
require('./kendo.html.button.js');
require('./kendo.button.menu.js');
require('./kendo.dropdownbutton.js');
require('./kendo.buttongroup.js');
require('./kendo.togglebutton.js');
require('./kendo.button.js');
require('./kendo.badge.js');
require('./kendo.menu.js');
require('./kendo.editable.js');
require('./kendo.checkbox.js');
require('./kendo.toggleinputbase.js');
require('./kendo.html.input.js');
require('./kendo.dropdownlist.js');
require('./kendo.list.js');
require('./kendo.label.js');
require('./kendo.floatinglabel.js');
require('./kendo.actionsheet.js');
require('./dropdowns-loader-Bc4IELFi.js');
require('./kendo.virtuallist.js');
require('./valueMapper-q_OtZ-Tj.js');
require('./kendo.datepicker.js');
require('./kendo.calendar.js');
require('./kendo.selectable.js');
require('./kendo.dateinput.js');
require('@progress/kendo-dateinputs-common');
require('./kendo.numerictextbox.js');
require('./prefix-suffix-containers-BmDm564f.js');
require('./kendo.textbox.js');
require('./kendo.validator.js');
require('./kendo.otpinput.js');
require('./kendo.window.js');

var kendo$1 = kendo;

module.exports = kendo$1;
